var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 5.00016L11.2846 1.14357C12.1206 0.586235 13.2563 1.02533 13.5 2.00004L8.5 5.00016H5.5ZM18.3139 2.9416L19 4.99992H10.5L15.335 1.8917C16.4327 1.18604 17.9012 1.70361 18.3139 2.9416ZM5.75 6.24997C3.67893 6.24997 2 7.9289 2 9.99997V18C2 20.071 3.67893 21.75 5.75 21.75H17.75C19.8211 21.75 21.5 20.071 21.5 18V17.75H21.5001V16.5C22.6046 16.4999 23.5 15.6045 23.5 14.5C23.5 13.3954 22.6046 12.5 21.5001 12.5V11.25H21.5V9.99997C21.5 7.9289 19.8211 6.24997 17.75 6.24997H5.75ZM21.5 11.25H20.0483H18.5001C16.7051 11.25 15.2501 12.705 15.2501 14.5C15.2501 16.2949 16.7051 17.75 18.5001 17.75H21.5V16.6923V16.5H18.5C17.3954 16.5 16.5 15.6045 16.5 14.5C16.5 13.3954 17.3954 12.5 18.5 12.5H21.5V11.3077V11.25ZM10 10.25C10.1989 10.25 10.3897 10.329 10.5303 10.4696L13.5303 13.4696C13.8232 13.7625 13.8232 14.2374 13.5303 14.5303C13.2374 14.8232 12.7626 14.8232 12.4697 14.5303L10.75 12.8106V17C10.75 17.4142 10.4142 17.75 10 17.75C9.58579 17.75 9.25 17.4142 9.25 17V12.8106L7.53033 14.5303C7.23744 14.8232 6.76256 14.8232 6.46967 14.5303C6.17678 14.2374 6.17678 13.7625 6.46967 13.4696L9.46967 10.4696C9.61032 10.329 9.80109 10.25 10 10.25Z",
    fill: "#D5DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletArrowUp);
export default __webpack_public_path__ + "static/media/wallet_arrow_up.f85b410b572c569a879e0b0d27e5eb1d.svg";
export { ForwardRef as ReactComponent };